import React from 'react';
import { getPageBleedBox } from 'app/stores/project/page';
import { getPage, getPageImage } from 'app/stores/selectors';
import { useConnect } from 'app/views/hooks/useConnect';
import { SlideView } from '../project/SlideView';
export const Slide = (props) => {
    const { slideId, keepAspectRatio = false } = props;
    const stateProps = useConnect(state => {
        const page = getPage(state, slideId);
        if (!page) {
            return null;
        }
        const image = getPageImage(state, slideId);
        return {
            page,
            image,
        };
    });
    if (!stateProps) {
        return null;
    }
    const { page, image } = stateProps;
    const bounds = getPageBleedBox(page, image);
    return (React.createElement(SlideView, { id: slideId, viewBox: bounds, keepAspectRatio: keepAspectRatio }));
};
